import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import { AnalyticsService } from '@vues/v-common/src/analytics';
import { createHead } from '@vueuse/head';
import "normalize.css";
import { installTooltips } from "@/common/tooltip";

import {dom } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
dom.watch();
installTooltips();

const app = createApp(App);

app.component("font-awesome-icon", FontAwesomeIcon);

app.use(router);
app.use(createHead());

// Audience of the app (visits, devices, loading time) : see administration > containers > v-business
AnalyticsService.start(router, {
  app: 'business',
  backUrl: process.env.VUE_APP_BACK_URL,
  enabled: process.env.NODE_ENV === 'production' && process.env.VUE_APP_ANALYTICS !== 'off',
  ignoredPrefixes: ['/administration'],   // The space of the super admin isn't part of the audience
  token: () => localStorage.token         // The logged user is recognized by his token : the users are counted, not the visitors
});


app.mount('#app');
